import { HttpService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';

interface AccreditationStatus{
  status:string,
  pendenciesNumber: string,
  revisionsNumber: string
}

export class ProviderAccreditationStatusService {

  public static async getAccreditationStatus(nrSeqAccreditation: number, nrSeqUser: number): Promise<any> {
    return await HttpService.get<AccreditationStatus>(Endpoint.GET.ACCREDITATION_STATUS, { nrSeqAccreditation, nrSeqUser });
  }

}
